/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaCheck/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaCheck({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaCheck",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#212529"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaCheck.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-1ju94T': alignSelf,'--mt-2-1ju94T': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1ju94T': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1ju94T': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1ju94T': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1ju94T': opacity,'--w-10-1ju94T': typeof width === 'number' ? `${width}px` : width,'--h-11-1ju94T': typeof height === 'number' ? `${height}px` : height,'--f-12-1ju94T': fill,'--a-7-1ju94T': isAnimated ? animation : "none",'--sd-8-1ju94T': isAnimated ? strokeDashoffset : 0,'--sd-9-1ju94T': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaCheck.SvgPath"
  data-view-path={viewPath}
 d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"
 style={{'--f-12-1ju94T': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}